import type { CapabilityNode } from '../types/capability';

/* The nodes to show at the first drill level of the capability picker  */
export function topLevelFromNodes(nodes: CapabilityNode[]): CapabilityNode[] {
  const roots = nodes.filter((node) => node.parentId === null);
  if (roots.length === 1 && !roots[0].selectable) {
    const children = nodes.filter((node) => node.parentId === roots[0].id);

    // Only unwrap a root that has something behind it
    if (children.length > 0) return children;
  }
  return roots;
}
